'use client';

import { Progress } from '@heroui/react';

const STATUS_LABELS: Record<string, string> = {
    NOT_FOUND: 'Starting up…',
    PLANNED: 'Getting your report ready…',
    INSIGHTS_READY: 'Finalizing insights…',
    RUNNING: 'Generating report…',
    ANALYSES_COMPLETE: 'Analysis complete, finishing up…',
    COMPLETE: 'Report ready!',
    FAILED: 'Generation failed',
};

interface ReportProgressBarProps {
    percent: number;
    status: string;
}

export function ReportProgressBar({ percent, status }: ReportProgressBarProps) {
    const isFailed = status === 'FAILED';
    const isComplete = status === 'COMPLETE';
    const label = STATUS_LABELS[status] ?? 'Generating…';

    return (
        <div className="mt-3 flex flex-col gap-1.5">
            <div className="flex items-center justify-between">
                <span className="text-xs font-medium text-foreground/60">{label}</span>
                <span className="text-xs font-semibold tabular-nums text-foreground/70">
                    {percent}%
                </span>
            </div>
            <Progress
                aria-label={`Report generation: ${label}`}
                value={percent}
                size="sm"
                radius="full"
                color={isFailed ? 'danger' : isComplete ? 'success' : 'primary'}
                classNames={{
                    track: 'bg-default-200/60',
                }}
            />
        </div>
    );
}
